import { changeCallingNumber, getCallingNumbers } from '../services/ccs-api.service'

/* eslint-disable no-shadow */
const state = () => ({
  selectedCallingNumber: null,
  availableCallingNumbers: [],
  fetched: null,
  fetching: false,
})

const getters = {
  getAvailableCallingNumbers(state) {
    return state.availableCallingNumbers
  },
  getSelectedCallingNumber(state) {
    return state.selectedCallingNumber
  },
}

const mutations = {
  setAvailableCallingNumbers(state, flag) {
    state.availableCallingNumbers = flag
  },
  setSelectedCallingNumber(state, flag) {
    state.selectedCallingNumber = flag
  },
  setFetching(state, bool) {
    state.fetching = bool
  },
  setFetched(state, time) {
    state.fetched = time
  },
}

// actions
const actions = {
  async fetchCallingNumbers(context, agentId) {
    if (context.state.fetching) return

    const now = new Date().getTime()
    if (context.state.fetched && now - context.state.fetched < 1000 * 60 * 5) return

    try {
      context.commit('setFetching', true)
      const callingNumbers = await getCallingNumbers(agentId)
      context.commit('setAvailableCallingNumbers', callingNumbers.displayNumbers)
      context.commit('setSelectedCallingNumber', callingNumbers.selectedNumber)
      context.commit('setFetched', new Date().getTime())
    } catch (e) {
      console.error('Error fetching calling numbers', e)
    } finally {
      context.commit('setFetching', false)
    }
  },
  async changeCallingNumber(context, displayNumber) {
    const changedCallingNumber = await changeCallingNumber(context.rootGetters['account/login'], displayNumber)
    context.commit('setSelectedCallingNumber', changedCallingNumber ? changedCallingNumber.toString() : null)
  },
  clearCallingNumbers(context) {
    context.commit('setAvailableCallingNumbers', [])
    context.commit('setSelectedCallingNumber', null)
    context.commit('setFetched', null)
  },
  setCallingNumbers(context, info) {
    context.commit('setCallingNumbers', info)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
